if (!customElements.get('studio-shipping-bar')) {
  // One request per page; the country is detected by Shopify on this shop's own domain.
  let detectedCountry;
  const getDetectedCountry = () => {
    if (!detectedCountry) {
      detectedCountry = (async () => {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 4000);
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false`, {
            signal: controller.signal,
            credentials: 'same-origin',
            headers: { Accept: 'application/json' }
          });
          if (!response.ok) return null;
          const context = await response.json();
          return context.detected_values?.country?.handle || null;
        } catch (_) {
          return null; // Keep the country that Shopify rendered when detection is unavailable.
        } finally {
          clearTimeout(timeout);
        }
      })();
    }
    return detectedCountry;
  };

  customElements.define('studio-shipping-bar', class extends HTMLElement {
    connectedCallback() {
      this.date = this.querySelector('[data-shipping-date]');
      this.updateDate = () => {
        // Add calendar days in Dutch/Belgian time, including weekends and DST changes.
        const parts = new Intl.DateTimeFormat('en-CA', {
          timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit'
        }).formatToParts(new Date());
        const calendar = Object.fromEntries(parts.map(({ type, value }) => [type, value]));
        const days = Math.max(1, Math.min(7, Number(this.dataset.days) || 1));
        const dispatch = new Date(Date.UTC(Number(calendar.year), Number(calendar.month) - 1, Number(calendar.day) + days));
        this.date.dateTime = dispatch.toISOString().slice(0, 10);
        this.date.textContent = new Intl.DateTimeFormat('nl-NL', {
          timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'long'
        }).format(dispatch);
      };
      this.updateDate();
      this.timer = setInterval(this.updateDate, 60000);
      document.addEventListener('visibilitychange', this.updateDate);
      this.setCountry(this.dataset.country);
      if (!this.hasAttribute('data-editor')) {
        getDetectedCountry().then(country => {
          if (this.isConnected && country) this.setCountry(country);
        });
      }
    }

    setCountry(country) {
      const code = country === 'BE' ? 'BE' : 'NL';
      this.querySelectorAll('[data-shipping-country]').forEach(item => {
        item.hidden = item.dataset.shippingCountry !== code;
      });
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.updateDate);
    }
  });
}
